import { Trip } from "../Trip/Trip";

export class ReportHour{
    datetime:string;
    trips:Array<Trip>;

    constructor(datetime:string,trips:Array<Trip>){
        this.datetime = datetime;
        this.trips = trips;
    }
}


// WEBPACK FOOTER //
// ./src/app/DataStructures/Report/ReportHour.ts